
import clsBaseGlobal from './base'

const arrFillable = [
    "dummy"    
];

// As for now this is a dummy which will eventually contain user settings.
class clsGlobalUser extends clsBaseGlobal {

    dummy     = null;

    get fillable() { return arrFillable; }

}

export default clsGlobalUser;